import PricebookClauseEditor from "./PricebookClauseEditor";

export default PricebookClauseEditor;
